import {
    PURCHASE_ORDER_REQUEST,
    PURCHASE_ORDER_SUCCESS,
    PURCHASE_ORDER_FAIL,
  } from "../constants/AuthConstant";
  
  import axios from "axios";
  import { toast } from "react-toastify";
  
  export const PurchaseOrderAction = (data) => {
    return function (dispatch) {
      return new Promise((resolve, reject) => {
        dispatch({
          type: PURCHASE_ORDER_REQUEST,
          payload: true,
        });
        let OPTION = {
          url: `${process.env.REACT_APP_API_PATH}/ebench/create_purchase_order`,
          method: "POST",
          data: data,
          headers: {
            "content-type": "application/json",
          },
        };
        axios(OPTION)
          .then((res) => {
            dispatch(updateDashboardContentPre(res.data));
            resolve(res.data);
          })
          .catch((error) => {
            toast.error(error?.response?.data?.status?.message || "Failed to create purchase order");
            dispatch({
              type: PURCHASE_ORDER_FAIL,
              payload: false,
              error: error,
              msg: "Failed to load the information",
            });
            reject(error);
          });
      });
    };
  };
  
  export const updateDashboardContentPre = (data) => {
    toast.success("Order Created Successfully!");
    return {
      type: PURCHASE_ORDER_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };
  

  // =========== ===================== ================== ================= ================ ==========

  export const PurchaseOrderDetailsAction = (id) => {
    return function (dispatch) {
      return new Promise((resolve, reject) => {
        dispatch({
          type: PURCHASE_ORDER_REQUEST,
          payload: true,
        });
  
        let OPTION = {
          url: `${process.env.REACT_APP_API_PATH}/ebench/get_purchase_order_by_interview_id?interviewId=${id}`,
          method: "GET",
          // data: data,
          headers: {
            "content-type": "application/json",
          },
        };
  
        axios(OPTION)
          .then((res) => {
            dispatch(updateDashboardContentPre1(res.data));
            resolve(res.data); // Resolving the promise with the response data
          })
          .catch((error) => {
            // toast.error(error?.response?.data?.status?.message || "Failed to create purchase order");
            dispatch({
              type: PURCHASE_ORDER_FAIL,
              payload: false,
              error: error,
              msg: "Failed to load the information",
            });
            reject(error); // Rejecting the promise with the error
          });
      });
    };
  };
  
  export const updateDashboardContentPre1 = (data) => {
    // toast.success("Order Created Successfully!");
    return {
      type: PURCHASE_ORDER_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };


  // ===================== selected purchase order candidate details ===========================

export const GetSelectedPurchaseDetails = ({ search, size, pageNumber, activeTab, status }) => {
    return function (dispatch) {
      return new Promise((resolve, reject) => {
        dispatch({
          type: PURCHASE_ORDER_REQUEST,
          payload: true,
        });
  
        let OPTION = {
          url: `${process.env.REACT_APP_API_PATH}/ebench/get_purchase_order_list?search=${search}&pageNumber=${pageNumber}&pageSize=${size}&purchaseOrderType=${activeTab}&status=${status}`,
          method: "GET",
          // data: data,
          headers: {
            "content-type": "application/json",
          },
        };
  
        axios(OPTION)
          .then((res) => {
            dispatch(successPurchaseList(res.data));
            resolve(res.data); // Resolving the promise with the response data
          })
          .catch((error) => {
            toast.error(error?.response?.data?.status?.message || "Failed to create purchase order");
            dispatch({
              type: PURCHASE_ORDER_FAIL,
              payload: false,
              error: error,
              msg: "Failed to load the information",
            });
            reject(error); // Rejecting the promise with the error
          });
      });
    };
  };
  
  export const successPurchaseList = (data) => {
    // toast.success("Order Created Successfully!");
    return {
      type: PURCHASE_ORDER_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };
  
  // =========================== purchase order details by purchase_Id ===============================

  export const PurchaseOrderByPurchaseId = (id) => {
    return function (dispatch) {
      return new Promise((resolve, reject) => {
        dispatch({
          type: PURCHASE_ORDER_REQUEST,
          payload: true,
        });
  
        let OPTION = {
          url: `${process.env.REACT_APP_API_PATH}/ebench/get_purchase_order_by_id?purchaseOrderId=${id}`,
          method: "GET",
          // data: data,
          headers: {
            "content-type": "application/json",
          },
        };
  
        axios(OPTION)
          .then((res) => {
            dispatch(purchaseOrderResult(res.data));
            resolve(res.data); // Resolving the promise with the response data
          })
          .catch((error) => {
            toast.error(error?.response?.data?.status?.message || "Failed to create purchase order");
            dispatch({
              type: PURCHASE_ORDER_FAIL,
              payload: false,
              error: error,
              msg: "Failed to load the information",
            });
            reject(error); // Rejecting the promise with the error
          });
      });
    };
  };
  
  export const purchaseOrderResult = (data) => {
    // toast.success("Order Created Successfully!");
    return {
      type: PURCHASE_ORDER_SUCCESS,
      result: data,
      payload: false,
      loading: false,
      msg: "SUCCESS",
    };
  };

  // ============================== purchase order list by vendor Id ======================================

  export const PurchaseOrderByVendorId = (search,pageNumber,size,purchaseOrderType,vendorId) => {
    return function (dispatch) {
      return new Promise((resolve, reject) => {
        dispatch({
          type: PURCHASE_ORDER_REQUEST,
          payload: true,
        });
  
        let OPTION = {
          url: `${process.env.REACT_APP_API_PATH}/ebench/get_purchase_order_by_vendor_id?search=${search}&pageNumber=${pageNumber}&pageSize=${size}&purchaseOrderType=${purchaseOrderType}&vendorId=${vendorId}`,
          method: "GET",
          // data: data,
          headers: {
            "content-type": "application/json",
          },
        };
  
        axios(OPTION)
          .then((res) => {
            dispatch(purchaseOrderByVendorIdResult(res.data));
            resolve(res.data); // Resolving the promise with the response data
          })
          .catch((error) => {
            toast.error(error?.response?.data?.status?.message || "Failed to create purchase order");
            dispatch({
              type: PURCHASE_ORDER_FAIL,
              payload: false,
              error: error,
              msg: "Failed to load the information",
            });
            reject(error); // Rejecting the promise with the error
          });
      });
    };
  };
  
  export const purchaseOrderByVendorIdResult = (data) => {
    // toast.success("Order Created Successfully!");
    return {
      type: PURCHASE_ORDER_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };

  // =============================== purchase order by candidate Id ===========================================

  export const PurchaseOrderByCandidateId = (search,pageNumber,size,candidateId) => {
    return function (dispatch) {
      return new Promise((resolve, reject) => {
        dispatch({
          type: PURCHASE_ORDER_REQUEST,
          payload: true,
        });
  
        let OPTION = {
          url: `${process.env.REACT_APP_API_PATH}/ebench/get_purchase_order_by_candidate_id?search=${search}&pageNumber=${pageNumber}&pageSize=${size}&candidateId=${candidateId}&purchaseOrderType=CANDIDATE_ORDER`,
          method: "GET",
          // data: data,
          headers: {
            "content-type": "application/json",
          },
        };
  
        axios(OPTION)
          .then((res) => {
            dispatch(purchaseOrderByCandidateResult(res.data));
            resolve(res.data); // Resolving the promise with the response data
          })
          .catch((error) => {
            toast.error(error?.response?.data?.status?.message || "Failed to create purchase order");
            dispatch({
              type: PURCHASE_ORDER_FAIL,
              payload: false,
              error: error,
              msg: "Failed to load the information",
            });
            reject(error); // Rejecting the promise with the error
          });
      });
    };
  };
  
  export const purchaseOrderByCandidateResult = (data) => {
    // toast.success("Order Created Successfully!");
    return {
      type: PURCHASE_ORDER_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };